import * as React from 'react';
import * as StudentActions from '../../actions/student';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { RootState } from '../../reducers';
import { StudentData } from '../../models/Student';

export namespace LoginStudent {
	export interface Props extends RouteComponentProps<void> {
		studentActions: typeof StudentActions;
		student: StudentData;
	}

	export interface State {
		/* empty */
	}
}

@connect(mapStateToProps, mapDispatchToProps)
export default class LoginStudent extends React.Component<LoginStudent.Props, LoginStudent.State> {

	username: HTMLInputElement;

	static contextTypes = {
		router: React.PropTypes.func.isRequired
	};

	constructor(props: LoginStudent.Props) {
		super(props);
		this.loginUser = this.loginUser.bind(this);
	}

	loginUser(e: any) {
		e.preventDefault();

		//remove teacher login
		localStorage.removeItem("token");

		const { studentActions } = this.props;
		const studentData: StudentData = {
			group: '',
			_id: '',
			firstname: '',
			lastname: '',
			email: '',
			username: this.username.value
		};
		studentActions.login(studentData);
	}

	componentDidUpdate() {
		const { student } = this.props;

		if (student._id) {
			this.context.router.history.push("/selectcampaign");
		}
	}

	render() {
		const { student } = this.props;

		return (
			<div>
				<div className="am_mainLogoContainer">
					<img className="margin30 am_mainLogo" src="/images/NarrapixBetaLogo.png" />
				</div>
				<h3 className="am_title text-center margin30">Oppilaan sovellus</h3>
				<div className="jumbotron am_studentcontainer col-6 offset-3">
					<form className="form-group" id="am_login" onSubmit={this.loginUser}>
						<input ref={(input) => this.username = input} className="col-12 form-control" placeholder="Kirjautumistunnus" required={true}/>
						<button type="submit" className="col-12 btn form-control am_green-button">KIRJAUDU</button>
					</form>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state: RootState) {
	return {
		student: state.student
	};
}

function mapDispatchToProps(dispatch: Dispatch<Function>) {
	return {
		studentActions: bindActionCreators(StudentActions as {}, dispatch)
	};
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/LoginStudent/index.tsx